(() => {
  const initArticleToc = () => {
    const toc = document.querySelector('.m-article-toc');
    const content = document.querySelector('.m-article__content');
    if (!toc || !content || toc.dataset.initialized === 'true') return;

    const headings = [...content.querySelectorAll('h2, h3')].filter(
      (heading) => heading.textContent.trim().length > 0
    );
    if (headings.length < 2) return;

    toc.dataset.initialized = 'true';
    const list = toc.querySelector('.m-article-toc__list');
    const indicator = toc.querySelector('.m-article-toc__indicator');
    const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));

    const makeId = (heading, index) => {
      if (heading.id) return heading.id;
      const base = heading.textContent
        .trim()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || `section-${index + 1}`;
      let id = base;
      let suffix = 2;
      while (usedIds.has(id)) id = `${base}-${suffix++}`;
      usedIds.add(id);
      heading.id = id;
      return id;
    };

    const links = headings.map((heading, index) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      const id = makeId(heading, index);
      item.className = `m-article-toc__item m-article-toc__item--${heading.tagName.toLowerCase()}`;
      link.className = 'm-article-toc__link';
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const top = heading.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
        history.replaceState(null, '', `#${id}`);
      });
      item.appendChild(link);
      list.appendChild(item);
      return link;
    });

    let activeIndex = -1;
    const setActive = (index) => {
      if (index === activeIndex) return;
      activeIndex = index;
      links.forEach((link, linkIndex) => {
        const isActive = linkIndex === index;
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });

      const activeLink = links[index];
      if (!activeLink) return;
      const panel = toc.querySelector('.m-article-toc__panel');
      indicator.style.height = `${activeLink.offsetHeight}px`;
      indicator.style.transform = `translateY(${activeLink.offsetTop}px)`;
      const centeredTop = activeLink.offsetTop + activeLink.offsetHeight / 2 - panel.clientHeight / 2;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      panel.scrollTo({
        top: Math.max(0, centeredTop),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    };

    const updateActive = () => {
      const marker = Math.min(180, window.innerHeight * .28);
      let index = 0;
      headings.forEach((heading, headingIndex) => {
        if (heading.getBoundingClientRect().top <= marker) index = headingIndex;
      });
      setActive(index);
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateActive();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      updateActive();
    });
    toc.hidden = false;
    updateActive();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleToc, { once: true });
  } else {
    initArticleToc();
  }

  document.addEventListener('shopify:section:load', initArticleToc);
})();
